export default __webpack_public_path__ + "static/media/T8-output1.e71d7e20.png";